import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row mmb-5" }
const _hoisted_2 = { class: "col span-6" }
const _hoisted_3 = {
  key: 0,
  class: "row provider-fields"
}
const _hoisted_4 = { class: "dns01-raw" }

import { computed } from 'vue';
import { useStore } from 'vuex';
import { get, set } from '@shell/utils/object';
import LabeledSelect from '@shell/components/form/LabeledSelect';
import Banner from '@components/Banner/Banner.vue';
import { LabeledInput } from '@components/Form/LabeledInput';
import { _EDIT } from '@shell/config/query-params';
import { useI18n } from '@shell/composables/useI18n';
import { DNS01_PROVIDERS } from '../../form-options';
import { DNS01_PROVIDER_FIELDS, hasFieldDescriptors } from './dns01-providers';

interface Props {
  /** The live `solver.dns01` object. Bound into directly so unrendered keys survive editing. */
  value: Record<string, any>;
  mode?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Dns01Provider',
  props: {
    value: {},
    mode: { default: _EDIT }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const store = useStore();
const { t } = useI18n(store);

const providerOptions = computed(() => DNS01_PROVIDERS.map((value) => ({ label: t(`certManager.dns01.provider.${ value }`), value })));

/**
 * The provider is whichever key is present on `dns01`. Reading it rather than storing it
 * separately means config written by hand or by an older cert-manager still shows up.
 */
const provider = computed<string | undefined>({
  get() {
    return Object.keys(props.value)[0];
  },
  set(neu) {
    Object.keys(props.value).forEach((key) => delete props.value[key]);

    if (neu) {
      props.value[neu] = {};
    }
  },
});

const fields = computed(() => (provider.value ? DNS01_PROVIDER_FIELDS[provider.value] : undefined) || []);

const isKnownProvider = computed(() => hasFieldDescriptors(provider.value));

const unknownProviderYaml = computed(() => JSON.stringify((provider.value ? props.value[provider.value] : undefined) || {}, null, 2));

function fieldValue(path: string) {
  return get((provider.value ? props.value[provider.value] : undefined) || {}, path);
}

function updateField(path: string, fieldValue: any) {
  // Write into the live provider object so keys this form does not render are preserved.
  set(props.value[provider.value as string], path, fieldValue === '' ? undefined : fieldValue);
}

__expose({
  provider, fields, isKnownProvider, unknownProviderYaml, fieldValue, updateField
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(LabeledSelect), {
          value: provider.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((provider).value = $event)),
          label: _unref(t)('certManager.dns01.providerLabel'),
          options: providerOptions.value,
          mode: __props.mode,
          taggable: true
        }, null, 8, ["value", "label", "options", "mode"])
      ])
    ]),
    _cache[2] || (_cache[2] = _createTextVNode()),
    (isKnownProvider.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields.value, (field) => {
            return (_openBlock(), _createElementBlock("div", {
              key: field.path,
              class: "col span-6"
            }, [
              _createVNode(_unref(LabeledInput), {
                value: fieldValue(field.path),
                label: _unref(t)(field.labelKey),
                required: field.required,
                mode: __props.mode,
                "onUpdate:value": v => updateField(field.path, v)
              }, null, 8, ["value", "label", "required", "mode", "onUpdate:value"])
            ]))
          }), 128))
        ]))
      : (provider.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(Banner, {
              color: "info",
              label: _unref(t)('certManager.dns01.unknownProvider', { provider: provider.value })
            }, null, 8, ["label"]),
            _cache[1] || (_cache[1] = _createTextVNode()),
            _createElementVNode("pre", _hoisted_4, _toDisplayString(unknownProviderYaml.value), 1)
          ], 64))
        : _createCommentVNode("", true)
  ]))
}
}

})